import LockerMenu from '../../Components/TopMenu'
import { PageWrapper } from '../../Styles/style';
import S1_Header from './S1_Header';
import S2_Partners from './S2_Partners';
import S3_Features from './S3_Incognito';
import S4_Stats from './S4_Mixer';
import S5_SSS from './S5_InstantWallet';
import S9_Footer from './S9_Footer';

import Aos from "aos";
import "aos/dist/aos.css";
import React, { useEffect } from 'react';
import Minbg from "../../../assets/images/mainbg.png"
import styled from '@emotion/styled';
import S6_ExploreDapps from './S6_ExploreDapps';
import S7_Faqs from './S7_Tokenomics';
import logo from "../../../assets/images/logo.png"
const Wrapper = styled.div`
min-height: 100vh;
background-image: url(${Minbg});
background-size: cover;
background-position: center;
`
const MainPage = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
    window.addEventListener("load", function () {
      Aos.init();
    });
  }, []);
  return (
    <PageWrapper>
      <Wrapper>
      <LockerMenu logo={logo}/>
      <S1_Header />
      </Wrapper>
      <S2_Partners/>
      <S3_Features/>
      <S4_Stats/>
      <S5_SSS/>
      <S6_ExploreDapps/>
      <S7_Faqs/>
      <S9_Footer/>
    </PageWrapper>
  )
}

export default MainPage